import Tooltip from "@common/components/Tooltip/Tooltip";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Root = styled(Tooltip)`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.4rem;
`;

export const FilterButton = styled.div<{ $isActive: boolean }>`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 10px;
  background: ${vars.colors.black};
  border: 0.15rem solid ${vars.colors.grey90};
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: #64b1fd26;
      border: 0.15rem solid #64b1fd80;

      svg path {
        stroke: #64b1fd;
      }
    `}
`;
